export const KEYS = {
  employees:   (params) => ['employees', params],
  employee:    (id)     => ['employees', id],
  attendance:  (empId, month, year) => ['attendance', empId, month, year],
  attSummary:  (month, year)        => ['attendance', 'summary', month, year],
  payrollRuns: (params) => ['payrollRuns', params],
  payrollRun:  (id)     => ['payrollRuns', id],
  dashboard:   ()       => ['reports', 'dashboard'],
  trend:       (months) => ['reports', 'trend', months],
  ytd:         (year)   => ['reports', 'ytd', year],
  departments: (m, y)   => ['reports', 'departments', m, y],
  advances:    (params) => ['advances', params],
  me:          ()       => ['auth', 'me'],
};